import { render, staticRenderFns } from "./ValinsProtocol.vue?vue&type=template&id=876b81ea&scoped=true"
import script from "./ValinsProtocol.vue?vue&type=script&lang=js"
export * from "./ValinsProtocol.vue?vue&type=script&lang=js"
import style0 from "./ValinsProtocol.vue?vue&type=style&index=0&id=876b81ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876b81ea",
  null
  
)

export default component.exports